import { Button, Card, Col, Form, Row, Skeleton } from "antd";
import { useEffect, useState } from "react";

import DescriptionEditor from "../components/DescriptionEditor";
import apiPath from "../constants/apiPath";
import useRequest from "../hooks/useRequest";
import { Severty, ShowToast } from "../helper/toast";
import lang from "../helper/langHelper";
import Main from "../components/layout/Main";
import NormalEditor from "../components/NormalEditor";
const slug = {
  PRIVACY_POLICY: "privacy-policy",
  TERMS_AND_CONDITIONS: "terms-conditions",
  ABOUT_US: "about-us",
  FAQ: "faq",
  DRIVER_AGREEMENT: "driver-agreement",
};

const ContentManagerForm = () => {
  const [form] = Form.useForm();

  const { request } = useRequest();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [content, setContent] = useState();
  const [termArDescription, setTermArDescription] = useState("");
  const [termDescription, setTermDescription] = useState("");
  const [policyArDescription, setPolicyArDescription] = useState("");
  const [policyDescription, setPolicyDescription] = useState("");
  const [faqArDescription, setFaqArDescription] = useState("");
  const [faqDescription, setFaqDescription] = useState("");
  const [aboutDescription, setAboutDescription] = useState("");
  const [aboutArDescription, setAboutArDescription] = useState("");

  const getContent = () => {
    request({
      url: apiPath.content,
      method: "GET",
      onSuccess: ({ data }) => {
        console.log(data.data);
        let privacyPolicy;
        let termsAndConditions;
        let faq;
        let aboutUs;

        data.data.forEach((item) => {
          if (item.slug === slug.PRIVACY_POLICY) {
            privacyPolicy = item;
          } else if (item.slug === slug.TERMS_AND_CONDITIONS) {
            termsAndConditions = item;
          } else if (item.slug === slug.FAQ) {
            faq = item;
          } else if (item.slug === slug.ABOUT_US) {
            aboutUs = item;
          }
        });

        setContent({
          privacyPolicy,
          termsAndConditions,
          aboutUs: aboutUs,
          faq: faq,
        });

        setTermArDescription(termsAndConditions?.ar_description);
        setTermDescription(termsAndConditions?.description);

        setPolicyArDescription(privacyPolicy?.ar_description);
        setPolicyDescription(privacyPolicy?.description);

        setLoading(false);
        form.setFieldsValue({
          terms_and_conditions: termsAndConditions?.description,
          ar_terms_and_conditions: termsAndConditions?.ar_description,
          privacy_policy: privacyPolicy?.description,
          ar_privacy_policy: privacyPolicy?.ar_description,
        });
      },
      onError: () => setLoading(false),
    });
  };

  const onFinish = (values) => {
    setSubmitting(true);
    // ShowToast("Content saved successfully", Severty.SUCCESS);
    let privacyPolicy = content?.privacyPolicy;
    let termsAndConditions = content?.termsAndConditions;

    const payload = [
      {
        name: termsAndConditions?.name,
        ar_name: termsAndConditions?.ar_name,
        id: termsAndConditions?._id,
        description: values?.terms_and_conditions,
        ar_description: values?.ar_terms_and_conditions,
      },
      {
        name: privacyPolicy?.name,
        ar_name: privacyPolicy?.ar_name,
        id: privacyPolicy?._id,
        description: values?.privacy_policy,
        ar_description: values?.ar_privacy_policy,
      },
    ];

    request({
      url: apiPath.content,
      method: "PUT",
      data: { content: payload },
      onSuccess: (data) => {
        setSubmitting(false);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setSubmitting(false);
      },
    });
  };

  const handleEditorChange = (data, type) => {
    switch (type) {
      case "term":
        return setTermDescription(data);
      case "term_ar":
        return setTermArDescription(data);
      case "about":
        return setAboutDescription(data);
      case "ar_about":
        return setAboutArDescription(data);
     
      case "policy":
        return setPolicyDescription(data);
      case "policy_ar":
        return setPolicyArDescription(data);
      case "service_provider":
        return setFaqDescription(data);
      case "ar_service_provider":
        return setFaqArDescription(data);
      default:
        return console.log("Unknown type");
    }
  };

  useEffect(() => {
    setLoading(true);
    getContent();
  }, []);

  return (
    <>

      {loading ? (
        [1, 2, , 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <Card>
          <Form form={form} onFinish={onFinish} className="cms-page">
            {/* About Us section removed */}
            <Row gutter={24}>
              <Col md={12}>
                <h4>{lang("Page: Terms And Conditions (English)")}</h4>
                <Form.Item
                  name="terms_and_conditions"
                  rules={[
                    {
                      required: true,
                      message: lang("Please Enter the Terms And Conditions!"),
                    },
                  ]}
                >
                  <NormalEditor
                    content={termDescription}
                    placeholder={lang("Enter Terms And Conditions")}
                    onChange={(data) => handleEditorChange(data, "term")}
                  />
                </Form.Item>
              </Col>

              <Col md={12}>
                <h4>{lang("Page: Terms And Conditions (Arabic)")}</h4>
                <Form.Item
                  name="ar_terms_and_conditions"
                  rules={[
                    {
                      required: true,
                      message: lang("Please Enter Terms And Conditions!"),
                    },
                  ]}
                >
                  <NormalEditor
                    content={termArDescription}
                    placeholder={lang("Enter Terms And Conditions")}
                    onChange={(data) => handleEditorChange(data, "term_ar")}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col md={12}>
                <h4>{lang("Page: Privacy Policy (English)")}</h4>
                <Form.Item
                  name="privacy_policy"
                  rules={[
                    {
                      required: true,
                      message: lang("Please Enter Privacy Policy!"),
                    },
                  ]}
                >
                  <NormalEditor
                    content={policyDescription}
                    placeholder={lang("Enter Privacy Policy")}
                    onChange={(data) => handleEditorChange(data, "policy")}
                  />
                </Form.Item>
              </Col>

              <Col md={12}>
                <h4>{lang("Page: Privacy Policy (Arabic)")}</h4>
                <Form.Item
                  name="ar_privacy_policy"
                  rules={[
                    {
                      required: true,
                      message: lang("Please Enter Privacy Policy!"),
                    },
                  ]}
                >
                  <NormalEditor
                    content={policyArDescription}
                    placeholder={lang("Enter Privacy Policy")}
                    onChange={(data) => handleEditorChange(data, "policy_ar")}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* How it works section removed */}

            <Row>
              <Button
                loading={submitting}
                className="primary_btn btnStyle"
                htmlType="submit"
              >
                {lang("Save Changes")}
              </Button>
            </Row>
          </Form>
        </Card>
      )}

    </>
  );
};

export default ContentManagerForm;
